const scrapingTagEditorFormRules = {
  name: [
    {
      required: true,
      message: 'Please provide a tag name',
    },
  ],
}

export default scrapingTagEditorFormRules
